var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-slider",attrs:{"id":"slider"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('isSlider',{attrs:{"carouselData":_vm.sliderItems,"carouselInterval":5000,"carouselItemWidth":1140}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }